import React from 'react';
import DataStateNotice from './DataStateNotice';

/** A result preview holds at most this many rows. */
export const RESULT_ROW_CAP = 100;

export interface ResultCapNoticeProps {
  rows: readonly unknown[];
  /** The API's word on whether the rows were cut. Left out, 100 rows or more count as cut. */
  truncated?: boolean;
}

/** Says the rows on screen are the first 100 only. Shown when they were cut, never for a complete result. */
const ResultCapNotice: React.FC<ResultCapNoticeProps> = ({ rows, truncated }) =>
  truncated ?? rows.length >= RESULT_ROW_CAP ? (
    <DataStateNotice tone="info" title="Showing the first 100 rows. Totals and charts cover these rows only." />
  ) : null;

export default ResultCapNotice;
